var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PostSearchHeader',{scopedSlots:_vm._u([{key:"header-title",fn:function(){return [_vm._v(" Reference Library ")]},proxy:true},{key:"header-description",fn:function(){return [_vm._v(" Comprehensive summaries for ~300 conditions and decision aids for applicable genetic testing strategies. ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }